<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Q0ozfn/Images/FC-9781528956581.jpg?1685327560664" alt="This image is the cover for the book A Mindful Afflatus"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Mindful Afflatus
      </h1>
      <p class="bookDescription body article font2">
        <p>Based on a true story of a very strange two-week eerie phenomenon that took place in an old flat in south London. Live my thoughts and feelings around the scary happenings as the uninvited guest gradually consumes my daily life.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Steve Bennett
      </h2>
      
      <p class="authorDescription body article">Steve works as a dispensing optician and is currently living in Somerset with his wife, two sons, daughter and two rather large Leonberger dogs. He spends his relaxing time (when not being hounded by the dogs) trying to play guitar and writing songs and has been designing and developing a board game on and off for the past ten years!</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?35c4a67c